import { useState } from 'react';
import icons from '../constants/icons';
import { cn } from '../utils/utils';
import { ReactSVG } from 'react-svg';
import { iconColor } from '../utils/functions';
import { COLORS } from '../constants/constants';

const ImagesSlide = ({ images, imagesStyle, dotsColor, arrowColor }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };
  return (
    <div className='relative rounded-xl overflow-hidden w-full'>
      {/* Background image */}
      <img src={images?.[currentIndex]?.documentFileUrl} className={cn('w-full object-cover', imagesStyle)} />
      {/* Gradient Overlay */}
      <div className='absolute inset-0 color-gradient' />

      {images?.length > 1 && (
        <>
          {/* Arrows */}
          <ReactSVG
            src={icons.slide_arrow_icon}
            className='rotate-180 absolute cursor-pointer top-1/2 left-4 -translate-y-1/2 z-10'
            onClick={prevSlide}
            beforeInjection={(svg) => iconColor(svg, arrowColor)}
          />
          <ReactSVG
            src={icons.slide_arrow_icon}
            className='absolute top-1/2 right-4 cursor-pointer -translate-y-1/2 z-10'
            onClick={nextSlide}
            beforeInjection={(svg) => iconColor(svg, arrowColor)}
          />
        </>
      )}

      {/* Dots */}
      <div className='absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10'>
        {images?.map((_, index) => (
          <span
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={cn(
              'h-2 rounded-full cursor-pointer transition-all duration-300',
              currentIndex === index ? `${dotsColor ?? 'bg-primary'} w-10` : 'bg-white w-3',
            )}
          />
        ))}
      </div>
    </div>
  );
};
export default ImagesSlide;
